module.exports = __webpack_public_path__ + "static/media/Ground Floor.58652f6c.webp";